export interface DeviceGroup_Interface {
  id:number,
  title:String,
  pm_program_id:number,
  parent:number,
  del:boolean,
  child:Array<DeviceGroup_Interface>
}

export function Empty_DeviceGroup_Interface(){
  return{
    id:0,
    title:'',
    pm_program_id:0,
    parent:0,
    del:false,
    child:[]
  }
}
